export default [
    {
        path: '/tools/sales-reports',
        name: 'sales_reports',
        meta: {
            requiresAuth: true,
            title: 'Sales Reports',
        },
        components: {
            agent: () => import('@views/tools/SalesReportingIndex.vue'),
        },
    },
    {
        path: '/tools/historical-quotes',
        name: 'historical_quotes',
        meta: {
            requiresAuth: true,
            title: 'Historical quotes',
        },
        components: {
            agent: () => import('@views/tools/HistoricalQuoteIndex.vue'),
        },
    },
    {
        path: '/tools/other-insurance',
        name: 'other_insurance',
        meta: {
            requiresAuth: true,
            title: 'Covers with other',
        },
        components: {
            agent: () => import('@views/tools/OtherInsuranceIndex.vue'),
        },
    },
];
